module.exports = __webpack_public_path__ + "changelog-video-thumbnail-42d756a2fe2d1f1f0ea917d442071db1.webp";